export default class EventGameFixtureEnumModel {
  public options: string[] = [];
}
